import { render, staticRenderFns } from "./add-section-card-icon-top.vue?vue&type=template&id=77792056&"
import script from "./add-section-card-icon-top.vue?vue&type=script&lang=js&"
export * from "./add-section-card-icon-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports